module.exports = __webpack_public_path__ + "static/media/card-transparent-background.edab21a5.svg";